import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import ServiceMain from './ServiceMain';
import Footer from '../../components/Footer';

const Service = () => {
  return (
    <>
      <HeaderSeven />

      <ServiceMain />

      <Footer />
    </>
  );
};

export default Service;
